import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorGeneralRewards = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.26 2.77 2.77 0 0 0-2.19 2.262L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="m21.75 6 .009.06c.049.378.36.668.742.69l-.029.005a.894.894 0 0 0-.721.745.834.834 0 0 0-.682-.738l-.068-.012a.79.79 0 0 0 .747-.717L21.75 6Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M12 4.208a7.792 7.792 0 1 0 0 15.584 7.792 7.792 0 0 0 0-15.584ZM2.792 12a9.208 9.208 0 1 1 18.416 0 9.208 9.208 0 0 1-18.416 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="M11.622 7.972a.395.395 0 0 1 .756 0l.861 2.789h2.843c.378 0 .54.48.24.709l-2.317 1.77.875 2.829a.395.395 0 0 1-.618.43L12 14.771 9.738 16.5a.395.395 0 0 1-.618-.43l.875-2.83-2.316-1.769a.395.395 0 0 1 .24-.71h2.842l.861-2.788Z"
    />
  </svg>
);
export default SvgTwoColorGeneralRewards;
